import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './menu-icon.scss';

function MenuIcon({ open }) {
  return (
    <div className={classNames('menu-icon', { 'is-open': open })}>
      <div className="menu-icon__bar menu-icon__bar--top" />
      <div className="menu-icon__bar menu-icon__bar--center" />
      <div className="menu-icon__bar menu-icon__bar--bottom" />
    </div>
  );
}

MenuIcon.propTypes = {
  open: PropTypes.bool,
};

MenuIcon.defaultProps = {
  open: false,
};

export default MenuIcon;
